import { Button } from "antd";
import { FormActions } from "../../components/common/FormActions";
import FormFields from "../../components/common/FormFields";
import { DISTRICT, FORM_DATA } from "../../utils/constants";
import {
  getRegister,
  createColumn,
  createEditAction,
  getForm,
  // objectWithUnsetKeys,
} from "../../utils/helpers";
import { URL_DISTRICTS } from "../../utils/urls";
import { useModals } from "../common/useModal";
import { API_DISTRICTS_PAGINATED } from "../../utils/apis";

export const useDistricts = () => {
  const { setLogo } = useModals();

  const handleViewLogo = (logoUrl: string) => {
    if (logoUrl) {
      setLogo(logoUrl);
    } else {
      console.warn("No logo URL provided");
    }
  };

  const tableColumns = () => [
    createColumn("name", true),
    createColumn("charge_mode", true),
    createColumn("vote_code", true),
    createColumn("logo", false),
    createColumn("actions", false),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        charge_mode: item?.charge_mode,
        logo: (
          <Button
            type="primary"
            size="small"
            onClick={() => handleViewLogo(item?.logo)}
            disabled={!item?.logo}
          >
            View Logo
          </Button>
        ),
        actions: (
          <FormActions actions={[createEditAction(URL_DISTRICTS, item?.id)]} />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_DISTRICTS);

  return { tableData, tableColumns, formRoute };
};

export const useDistrictsForm = ({ form, id }) => {
  const isEdit = !!id;
  const fields: any = [
    {
      field_name: "name",
      type: "text",
      label: "District name",
      props: { required: !isEdit },
    },
    {
      field_name: "charge_mode",
      type: "select",
      label: "Charge mode",
      props: { required: !isEdit },
      options_data: [
        { id: "minute", name: "Minute" },
        { id: "hour", name: "Hour" },
        { id: "flat", name: "Flat" },
      ],
    },
    {
      field_name: "vote_code",
      type: "text",
      label: "Vote Code",
      props: { required: !isEdit, disabled: isEdit },
    },
    {
      field_name: "logo",
      label: "Local Government Logo",
      type: "file",
      props: {
        required: !isEdit,
        placeholder: "Upload logo",
        accept: "image/*",
        multiple: false,
        document_type: "image",
      },
    },
  ];

  const sections: any = [
    {
      title: "District details",
      fields,
    },
  ];

  const redirect = getRegister(URL_DISTRICTS);

  const defaultValues = { location_type: DISTRICT };

  function onSubmit(payload: any, id: any) {
    const params = {
      ...payload,
      logo:
        Array.isArray(payload?.logo?.file) && payload?.logo?.file.length > 0
          ? payload?.logo?.file[0]
          : [],
    };

    const api = API_DISTRICTS_PAGINATED;
    if (id) {
      return {
        id,
        api,
        params: params,
        type: FORM_DATA,
      };
    }

    return {
      api,
      params: params,
      type: FORM_DATA,
    };
  }

  const enableSubmit = Object.keys(form).length > 0;

  return {
    fields,
    sections,
    onSubmit,
    enableSubmit,
    redirect,
    defaultValues,
  };
};

export const DistrictsForm = ({
  form,
  id,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { fields } = useDistrictsForm({ form, id });
  return (
    <FormFields
      fields={fields}
      error={error}
      form={form}
      updateFormValue={updateFormValue}
      onChange={onChange}
    />
  );
};
